<template>
  <span class="m-chat-file">
    <span v-if="!loading">
      <input id="chatFileIpt" type="file" @change="sendImage"/>
      <slot></slot>
    </span>
    <div style="float:right;margin-right: 20px;display:inline-block;" v-else>
      <Loading :width="20"></Loading>
    </div>
  </span>
</template>

<script>
import Loading from '../Loading'
export default {
  props: ['toAccountId'],
  data () {
    return {
      loading: false
    }
  },
  components: {
    Loading
  },
  computed: {
    nim () {
      return this.$store.state.nim
    }
  },
  methods: {
    sendImage () {
      this.nim.sendFile({
        scene: 'p2p',
        to: this.toAccountId,
        type: 'image',
        fileInput: 'chatFileIpt',
        beginupload: (upload) => {
          this.loading = true
          this.$forceUpdate()
          if (upload.options.fileSize / 1024 / 1024 > 20) {
            this.$message.error('发送文件不能超过20M');
            upload.abort()
          }
        },
        uploadprogress: (obj) => {
          console.log('文件总大小: ' + obj.total + 'bytes');
          console.log('已经上传的大小: ' + obj.loaded + 'bytes');
          console.log('上传进度: ' + obj.percentage);
          console.log('上传进度文本: ' + obj.percentageText);
        },
        uploaddone: (error, file) => {
          console.log(error);
          console.log(file);
          console.log('上传' + (!error?'成功':'失败'));
          this.loading = false
          this.$forceUpdate()
          if (error && error.code === 'abort') {
            return
          }
          if (error) {
            this.sendFile()
          }
        },
        beforesend: (msg) => {
          console.log('正在发送p2p image消息, id=' + msg.idClient);
          this.nim.pushMsg(msg);
        },
        done: function () {
          console.log('done')
        }
      })
    },
    sendFile () {
      this.nim.sendFile({
        scene: 'p2p',
        to: this.toAccountId,
        type: 'file',
        fileInput: 'chatFileIpt',
        beginupload: (upload) => {
          this.loading = true
          this.$forceUpdate()
        },
        uploadprogress: function(obj) {
          console.log('文件总大小: ' + obj.total + 'bytes');
          console.log('已经上传的大小: ' + obj.loaded + 'bytes');
          console.log('上传进度: ' + obj.percentage);
          console.log('上传进度文本: ' + obj.percentageText);
        },
        uploaddone: (error, file) => {
          console.log(error);
          console.log(file);
          console.log('上传' + (!error?'成功':'失败'));
          this.loading = false
          this.$forceUpdate()
          if (error && error.code === 'abort') {
            return
          }
        },
        beforesend: (msg) => {
          console.log('正在发送p2p file消息, id=' + msg.idClient);
          this.nim.pushMsg(msg);
        },
        done: function () {
          console.log('done')
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .m-chat-file {
    position: relative;
    width: 20px;

    input {
      position: absolute;
      top: 0;
      left: 0;
      opacity: 0;
      cursor: pointer;
      font-size: 16px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/chat/ChatFile.vue